import {  
    getFirestore, 
    doc,
    deleteDoc,
    // collection,
    // getDocs
} from "firebase/firestore";
const removeRewards = async function(id) {
    let db = getFirestore();
    // const query = collection(db, "wellness_rewards", id, "redeem_history");
    // const redemptionsSnapshot = await getDocs(query);
    // redemptionsSnapshot.forEach(async doc => {
    //     await deleteDoc(doc.ref);
    // });

    // delete the reward
    const docRef = doc(db, "wellness_rewards", id);
    await deleteDoc(docRef)
};

export default removeRewards;
